import { PopupContextProvider } from "./contexts/PopupContext";
import { QuoteControllerContextProvider } from "./contexts/QuoteControllerContext";
import Home from "./components/Home";
import { AuthProvider } from "./contexts/AuthContext";
import GTM from "./components/GTM";
import { useState, useEffect } from "react";
import configService from "./services/configService";

const App = () => {
  const [gtmId, setGtmId] = useState(null);

  useEffect(() => {
    const fetchGtmId = async () => {
      const containerid = await configService.getGtmContainerId();
      if (containerid) setGtmId(containerid);
    };
    fetchGtmId();
  }, []);

  return (
    <>
      <GTM gtmId={gtmId} />

      <AuthProvider>
        <QuoteControllerContextProvider>
          <PopupContextProvider>
            <Home />
          </PopupContextProvider>
        </QuoteControllerContextProvider>
      </AuthProvider>
    </>
  );
};

export default App;
